// scroll functions and listeners ---------------------------------------------

// imports --------------------------------------------------------------------
import {getPageCoordinates, getRelativeCoordinates} from '../js_vendor/GetCoordinates.js';
import ScrollAnimator from '../js_vendor/ScrollAnimator.js';

// import * as Listeners from './1-listeners.js';
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
import * as Page from './3-page.js';
import * as Resize from './4-resize.js';

// set user variables ---------------------------------------------------------
// which elements, when active, should block scroll
const blockScrollSelector = '.popover--active, .body--nav, .media--fullscreen';

// set code variables ---------------------------------------------------------
export let scrollAnimator;

export let scrollTop = 0;
export let scrollLeft = 0;
export let windowBottom = window.innerHeight;
export let windowRight = window.innerWidth;

export let atBodyBottom = false;
export let atBodyRight = false;
export let isScrolling = false;

// scroll listeners -----------------------------------------------------------
export const initScroll = () => {
  // scroll listener
  window.addEventListener('scroll', () => {
    // add code only called from real scroll here

    setScroll();
  }, {passive: true});

  scrollAnimator = new ScrollAnimator({
    durationFactor: 35, // 35 is good for most cases. Lower is faster, higher is slower
    minDuration: Vars.transitionDefault, // 400,
    allowOverride: true, // allow users overtaking the scroll animation by manually scrolling
    overrideThreshold: 120, // if the user scrolls more 
    onStart: (isDocumentScroll = false) => {
      if (!isDocumentScroll) return;
      isScrolling = true;
      checkBlockScroll();
    },
    onStop: (isDocumentScroll = false) => {
      if (!isDocumentScroll) return;
      isScrolling = false;
      checkBlockScroll();
    },
  });

  scrollAnimator.init();
};

// scroll function ------------------------------------------------------------
export const setScroll = () => {
  // do scrolling actions
  // console.log('setScroll');

  if ('fixer' in Once && typeof Once.fixer?.bodyFixed !== 'undefined') {
    if (Once.fixer.bodyFixed !== true) updateFromScroll();
  } else {
    updateFromScroll();
  }
};

const updateFromScroll = () => {
  scrollTop = window.scrollY || document.documentElement.scrollTop;
  scrollLeft = window.scrollX || document.documentElement.scrollLeft;

  windowBottom = scrollTop + window.innerHeight;
  windowRight = scrollLeft + window.innerWidth;

  // use >= becaues of ios scrolling past the max, -1 for smooth scroll
  atBodyBottom = scrollTop >= Resize.maxBodyScrollTop - 1;
  atBodyRight = scrollLeft >= Resize.maxBodyScrollLeft - 1;

  // console.log('updateFromScroll', {scrollTop, scrollLeft, windowBottom, windowRight, atBodyBottom, atBodyRight});

  Page.gradientEls.forEach(gradientEl => {
    const rect = gradientEl.getBoundingClientRect();
    if (rect.bottom <= Resize.viewportHeight) gradientEl.classList.add('gradient--visible');
  });

  Page.chartsEls.forEach(chartsEl => {
    const rect = chartsEl.getBoundingClientRect();
    if (rect.bottom <= Resize.viewportHeight * 1 + 100) chartsEl.classList.add('charts--visible');
  });
};

// functions -------------------------------------------------------------------
export const checkBlockScroll = () => {
  // console.log('checkBlockScroll', {isScrolling});
  const hasFixer = 'fixer' in Once && typeof Once.fixer?.bodyFixed !== 'undefined';
  const hasAnimator = 'animator' in Once && typeof Once.animator?.disableSmoothScroll !== 'undefined';
  if (document.querySelector(blockScrollSelector)) {
    // an element is active, which should block scroll
    if (hasFixer) Once.fixer.fixBody();
    if (hasAnimator) Once.animator.disableSmoothScroll();
  } else if (isScrolling) {
    // scroll is animating, so disable scroll
    if (hasAnimator) Once.animator.disableSmoothScroll();
  } else {
    // normal state, enable scroll
    if (hasFixer) Once.fixer.unfixBody();
    if (hasAnimator) Once.animator.enableSmoothScroll();
    if ('saveOffsets' in Resize) Resize.saveOffsets();
  }
};

// hard set scroll top
export const setScrollTop = (scroll) => {
  if ('animator' in Once && Once.animator?.scroller !== undefined) {
    Once.animator.setScrollPosHard({pos: scroll});
  } else {
    window.scrollTo({top: scroll});
  }
}

export const scrollToEl = (element, returnFunction = '', offset = Resize.headerHeight, direction = 'both') => {
  const top = getPageCoordinates(element).top - offset;

  if (direction === 'up' && top >= scrollTop) return;
  if (direction === 'down' && top <= scrollTop) return;

  scrollAnimator.animateScrollTop(top, {
    element: document.body,
    useMax: true,
    onDone: () => { if (typeof returnFunction === 'function') returnFunction(); },
  });
};

